/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { createContext, useCallback, useState, useContext } from 'react';

export enum EscrowAnalysisViews {
  CALCULATE_APPLY_AEA_VIEW,
  AEA_HISTORY_VIEW,
  MAIN_MENU_VIEW,
}

type ServicerEscrowAnalysisContextType = {
  viewToShow: EscrowAnalysisViews;
  setViewToShow: (val: EscrowAnalysisViews) => void;
};

const ServicerEscrowAnalysisContext = createContext<ServicerEscrowAnalysisContextType>({
  //showEscrowMonthsTable: false,
  viewToShow: EscrowAnalysisViews.MAIN_MENU_VIEW,
  setViewToShow: (val: EscrowAnalysisViews) => {},
});

const useServicerEscrowAnalysisContext = () => {
  const servicerEscrowAnalysisContext = useContext(ServicerEscrowAnalysisContext);
  if (servicerEscrowAnalysisContext === undefined) {
    /// throwing this error helps in development when the context is out of scope.
    throw new Error('servicerEscrowAnalysisContext must be inside a ServicerEscrowAnalysisProvider');
  }
  return servicerEscrowAnalysisContext;
};

const ServicerEscrowAnalysisProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [viewToShow, setViewToShow] = useState(EscrowAnalysisViews.MAIN_MENU_VIEW);

  return (
    <ServicerEscrowAnalysisContext.Provider value={{ viewToShow, setViewToShow }}>
      {children}
    </ServicerEscrowAnalysisContext.Provider>
  );
};

export { ServicerEscrowAnalysisProvider, useServicerEscrowAnalysisContext };
